define('viewmodels/pages/cash/PaymentWizard',[
    'knockout',
    'underscore',
    'bluebird',
    'viewmodels/Wizard',
    'common/clientSniffer',
    'common/tools'
], function (ko, _, Promise, Wizard, clientSniffer, tools) {

    /**
     * A Wizard for payment flows.
     *
     * An optional onPayment param allows specific methods to hook into to
     * payment promise chain.
     */
    function PaymentWizard(publishStepChanged, navigation, successRouteId, failureRouteId, getField, paymentModel, topBarAction, onCompleteHook, showError, params) {

        return new Wizard(publishStepChanged, _.extend(params || {}, {

            // Shitty over-opinionated apple have added some pointless scrolling when the on-screen
            // keyboard is displayed. This doesn't seem to play nice with all the flex boxing and
            // absolute positioning required to have a functioning layout in 2015 so it helpfully
            // scrolls all the content off the screen. Disable auto-focus for the payment flows on
            // iOS devices until someone fancies rewriting all our CSS to accommodate this useless
            // feature. @todo dhowlett Rewrite CSS to accommodate this useless feature.
            useAutoFocus: clientSniffer.OS.name !== 'iOS',
            backHook: topBarAction,
            onComplete: function() {

                // if we don't want to hook into the main onComplete then let the hook resolve immediately
                onCompleteHook = Promise.method(onCompleteHook || function () {
                    return true;
                });

                var self = this;

                // run the onCompleteHook and only proceed if we get a truthy response
                return onCompleteHook().then(function (proceed) {

                    if (!proceed) {
                        return;
                    }

                    var absoluteSuccessUrl = paymentModel.prepareSuccessUrl(
                            navigation.reverseRouteAbsolute(successRouteId)
                        ),
                        relativeSuccessUrl = paymentModel.prepareSuccessUrl(navigation.reverseRoute(successRouteId)),
                        promise = paymentModel.makePayment({
                            attributes: {
                                successUrl: absoluteSuccessUrl,
                                failureUrl: navigation.reverseRouteAbsolute(failureRouteId)
                            }
                        });


                    if (self.onPayment) {
                        promise = self.onPayment(promise);
                    }

                    return promise.then(function (result) {

                        if (!result) {
                            return;
                        }

                        if (result.redirectOutput && result.redirectOutput.url) {

                            if (result.redirectOutput.method === 'POST') {
                                tools.postToUrl(result.redirectOutput.url, result.redirectOutput.parameters);
                                return;
                            }

                            return navigation.navigateUrl( result.redirectOutput.url );
                        }

                        return navigation.navigateUrl( relativeSuccessUrl );

                    })
                        .then(null, function (e) {

                            if (e.errorKeys) {

                                // GENERIC FOR ALL METHODS
                                if (e.errorKeys === 'amountBelowLimit') {

                                    paymentModel.amount.invalidate('TOO_SMALL');
                                    self.returnToIncompleteStep();
                                    return;
                                }
                                else if (e.errorKeys === 'amountAboveLimit') {

                                    paymentModel.amount.invalidate('TOO_BIG');
                                    self.returnToIncompleteStep();
                                    return;
                                }

                                // try to find a relevant error message to show
                                var errorResponses = getField('error_responses')() || [];

                                var responseToShow = _.find(errorResponses, function(response) {
                                    // jshint -W069
                                    return _.includes(e.errorKeys, response['error_code']) && response['error_message'];
                                });

                                // if we have a response code we can map to an error then show it and return
                                if (responseToShow) {
                                    // jshint -W069
                                    showError(responseToShow['error_message']);
                                    return;
                                }
                            }

                            // @todo Log any unhandled errors
                            showError(getField('unexpected_error_message'));
                            throw e;

                        });
                });
            },
            methodInMaintenanceMode: paymentModel.playerPaymentMethod.property('inMaintenanceMode'),
            methodType: paymentModel.playerPaymentMethod.property('type').pipe(_.skipFalsy(function(type) {
                return type.toLowerCase();
            }))

        }));

    }

    return PaymentWizard;

});

